import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

class SumStar extends Component {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._onGetData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _onGetData = async () => {
    const result = await this._onGetDataApi();
    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const maxCount = result.data[0].maxCount;
    const avgCount = result.data[0].avgCount;
    const starList = result.data[0].listData;
    //console.log(intReturn)
    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          con,
          maxCount,
          avgCount,
          starList,
        });
      }
    }
  };
  _onGetDataApi = () => {
    const { apiUrl } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/starRating', {
        params: {
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  render() {
    const { starList, con, maxCount, avgCount } = this.state;
    ////console.log(starList)
    ////console.log(maxCount)
    if (starList) {
      const total =
        parseInt(starList[0].starCount) +
        parseInt(starList[1].starCount) +
        parseInt(starList[2].starCount) +
        parseInt(starList[3].starCount) +
        parseInt(starList[4].starCount);
      const totalValue = total / con;
      //console.log(totalValue);
    }

    return (
      <Fragment>
        {starList ? (
          <div className="width_auto">
            <div className="left_float_left">
              {avgCount}.0
              <div className="star_img3">
                <div
                  className="star_img3_on"
                  style={{ width: avgCount * 10 + '%' }}
                ></div>
              </div>
              <span>({con}개의 평가)</span>
            </div>

            <div className="left_float_right">
              <ul>
                <li>
                  <span>10</span>
                  <p
                    className={maxCount === starList[0].starCount ? 'on' : null}
                    style={{ width: (starList[0].starCount / con) * 100 + '%' }}
                  ></p>
                </li>
                <li>
                  <span>8</span>
                  <p
                    className={maxCount === starList[1].starCount ? 'on' : null}
                    style={{ width: (starList[1].starCount / con) * 100 + '%' }}
                  ></p>
                </li>
                <li>
                  <span>6</span>
                  <p
                    className={maxCount === starList[2].starCount ? 'on' : null}
                    style={{ width: (starList[2].starCount / con) * 100 + '%' }}
                  ></p>
                </li>
                <li>
                  <span>4</span>
                  <p
                    className={maxCount === starList[3].starCount ? 'on' : null}
                    style={{ width: (starList[3].starCount / con) * 100 + '%' }}
                  ></p>
                </li>
                <li>
                  <span>2</span>
                  <p
                    className={maxCount === starList[4].starCount ? 'on' : null}
                    style={{ width: (starList[4].starCount / con) * 100 + '%' }}
                  ></p>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <div className="width_auto">
            <div className="left_float_left">
              0.0
              <div className="star_img3">
                <div className="star_img3_on" style={{ width: '0%' }}></div>
              </div>
              <span>(0개의 평가)</span>
            </div>

            <div className="left_float_right">
              <ul>
                <li>
                  <span>10</span>
                  <p className="on" style={{ width: '0%' }}></p>
                </li>
                <li>
                  <span>8</span>
                  <p className="" style={{ width: '0%' }}></p>
                </li>
                <li>
                  <span>6</span>
                  <p className="" style={{ width: '0%' }}></p>
                </li>
                <li>
                  <span>4</span>
                  <p className="" style={{ width: '0%' }}></p>
                </li>
                <li>
                  <span>2</span>
                  <p className="" style={{ width: '0%' }}></p>
                </li>
              </ul>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(SumStar));
